import appConfig from '../../../functions/config.json';

export const webClientId = appConfig.webClientId;
